export const WARNING_TYPE = 'warning';
export const INFORMATION_TYPE = 'information';

export default class WorkAlertC {

    /**
     * @param {string} message
     * @param {string} type
     * @param {number} id
     * @param {boolean} closeable
     * @param {string} closeText
     * @param {Function} close
     */
    constructor({ message, type, id, closeable = true, closeText = undefined, close = undefined }) {
        this.message = message;
        this.type = type;
        this.id = id;
        this.closeable = closeable;
        this.closeText = closeText;
        this.close = close;
    }
}
